import { z } from "zod";

import { jsonHeaders } from "@/packages/dashboard/csrf";
import { withAppDomain } from "@/packages/dashboard/utils/url-utils";

import { mealSchema } from "./get-meals";

const mealResponseSchema = z.object({
  meal: mealSchema,
});

export type MealResponse = z.infer<typeof mealResponseSchema>;

export async function getMeal(mealId: number | string): Promise<MealResponse> {
  const response = await fetch(withAppDomain(`/api/v1/meals/${mealId}`), {
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch meal: ${response.statusText}`);
  }

  const data = await response.json();
  return mealResponseSchema.parse(data);
}
